import { apiDispatcher } from '../utils';

const baseUrl = '/api/v1/form';

export const getForms = (query?: string | null) => {
  return apiDispatcher<any>(`${baseUrl}${!!query ? '?cid=' + query : ''}`, 'GET');
};

